import {useCallback, useEffect, useState} from "react";
import {useNavigate, useOutletContext} from "react-router";
import Grid from "@mui/material/Grid2";
import {apiGet} from "../utils";
import {buildV2QueryParams, hasDateFilters} from "../utils/filters";
import {Alerts} from "../components/alerts/Alerts";
import {InactiveAccountsAlertTable} from "../components/alerts/InactiveAccountsAlertTable";
import {NegativeMarginAlertTable} from "../components/alerts/NegativeMarginAlertTable";
import {NoPriceChangesAlertTable} from "../components/alerts/NoPriceChangesAlertTable";
import {NegativeMarginSKUAlertTable} from "../components/alerts/NegativeMarginSKUAlertTable";
import {UnderPricedSKUAlertTable} from "../components/alerts/UnderPricedSKUAlertTable";
import {NegativeMarginAccountAlertTable} from "../components/alerts/NegativeMarginAccountAlertTable";

export const AlertsPanel = ({minimal = false}) => {
    const {filters} = useOutletContext();
    const navigate = useNavigate();
    const [alertsData, setAlertsData] = useState({});
    const [selectedAlertName, setSelectedAlertName] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchAlertsData = useCallback(() => {
        if (!hasDateFilters(filters)) {
            return;
        }

        const queryParams = buildV2QueryParams(filters);
        apiGet(`v2/alert/summary${queryParams}`, (resp) => {
            if (resp.success) {
                const reduced = {};
                for (const [alertName, data] of Object.entries(resp.data)) {
                    reduced[alertName] = data.calcs;
                }
                setAlertsData(reduced);
            }
        });
    }, [filters]);

    const fetchTableData = useCallback((alertName) => {
        if (!hasDateFilters(filters) || !alertName) {
            return;
        }
        setLoading(true);
        setTableData([]);
        const queryParams = buildV2QueryParams(filters);
        apiGet(`v2/alert/detail/${alertName}${queryParams}`, (resp) => {
            setTableData(resp.data);
            setLoading(false);
        });
    }, [filters]);

    useEffect(() => {
        fetchAlertsData();
    }, [fetchAlertsData]);

    useEffect(() => {
        fetchTableData(selectedAlertName);
    }, [filters, fetchTableData, selectedAlertName]);

    const handleAlertClick = (alertName) => {
        setSelectedAlertName(alertName);
    };

    const handleMinimalPanelAlertClick = (alertName) => {
        //TODO: pass navToAlerts function in Outlet... send alertName to that... set displayed alert on alerts page...
        console.log(`Clicked alert: ${alertName}`);
        navigate('/alerts');
    };

    return (
        minimal ?
            <div style={{marginTop: 30}}>
                <Alerts data={alertsData} clickHandler={handleMinimalPanelAlertClick} minimal/>
            </div>
            :
            <div style={{marginTop: 20, marginLeft: 30, marginRight: 30, marginBottom: 100}}>
                <Grid container justifySelf="center" spacing={2}>
                    <Grid size={12} justifyItems="center">
                        <Alerts data={alertsData} clickHandler={handleAlertClick}/>
                    </Grid>
                    <Grid size={12} justifyItems="center">
                        {selectedAlertName === 'negativeMarginOrders' &&
                            <NegativeMarginAlertTable data={tableData} loading={loading}/>
                        }
                        {selectedAlertName === 'negativeMarginSKUs' &&
                            <NegativeMarginSKUAlertTable data={tableData} loading={loading}/>
                        }
                        {selectedAlertName === 'underPricedSKUs' &&
                            <UnderPricedSKUAlertTable data={tableData} loading={loading}/>
                        }
                        {selectedAlertName === 'inactiveAccounts' &&
                            <InactiveAccountsAlertTable data={tableData} loading={loading}/>
                        }
                        {selectedAlertName === 'noPriceChanges' &&
                            <NoPriceChangesAlertTable data={tableData} loading={loading}/>
                        }
                        {selectedAlertName === 'negativeMarginAccounts' &&
                            <NegativeMarginAccountAlertTable data={tableData} loading={loading}/>
                        }
                    </Grid>
                </Grid>
            </div>
    )
};